import camelize from 'camelize';
import querystring from 'query-string';
import { compose, lifecycle, mapProps, withStateHandlers } from 'recompose';
import config from '../../../config';
import { showErrorMsg } from '../ErrorMsg';
import { withSpinnerWhileLoading } from '../Spinner';

export const ephotobookDataList = (options = {}) => {
    const params =
      Object.entries(options).map(([key, val]) => `${key}=${val}`).join('&');

    return $.get(`${config.localeApi}/ephotobook/list?${params}`)
    .fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    });
}

export const ephotobookOrderDataList = (param) => {
  return $.get(`${config.localeApi}/ephotobook/order-list?order_id=${param}`)
  .fail(({ responseJSON: { errors = '' } }) => {
    showErrorMsg(errors);
  });
}

export const ephotobookUpdateAccess = (data) => {
  return $.post({
    url: `${config.localeApi}/ephotobook/update_access`,
    dataType: 'json',
    contentType: 'application/json',
    jsonp: false,
    data: JSON.stringify(data),
  }).fail(({ responseJSON: { errors = '' } }) => {
      showErrorMsg(errors);
    });
};

export const ephotobookContentList = link => $.get(`${config.localeApi}/ephotobook/preview${link}`);

export const withEphotobookContentData = WrappedComponent => compose(
  withStateHandlers({
    errorMessage: null,
    loading: true,
    ephotobookDetails: {},
  }, {
    handleAsyncDone: () => (data) => ({
      loading: false,
      ephotobookDetails: data,
    }),
    handleAsyncFailed: () => errorMessage => ({
      loading: false,
      errorMessage,
    }),
  }),
  lifecycle({
    componentDidMount() {
      const {
        handleAsyncDone,
        handleAsyncFailed,
        location: {
          search = ''
        } = {}
      } = this.props;
      const {
        file = '',
        uuid = ''
      } = querystring.parse(search);
      const params = querystring.stringify(uuid ? { uuid } : { file });

      ephotobookContentList(`?${params}`)
        .done(({ data }) => handleAsyncDone(data))
        .fail((resp) => {
          const { errors } = resp.responseJSON;

          if ('string' === typeof errors) {
            handleAsyncFailed(errors);
          } else {
            const messageKey = Object
              .keys(errors)
              .find(key => key);
            const messages = errors[messageKey] || [];

            handleAsyncFailed(messages.shift());
          }
        });
    }
  }),
  withSpinnerWhileLoading,
  mapProps(({ ephotobookDetails, ...props }) => ({
    ephotobookDetails: camelize(ephotobookDetails),
    ...props
  })),
)(WrappedComponent);

export const addEphotobookToCart = ({ file }) =>
  $.post(`${config.localeApi}/cart/ephotobook_project`, {
    file
  })
    .fail((resp) => {
      const { errors = [] } = resp.responseJSON;
      const messageKey = Object
        .keys(errors)
        .find(key => key);
      const messages = errors[messageKey] || [];
      if (messages['precondition'] === 'user_verification') {
        const {
          data: {
            redirectUrl = ''
          } = {}
        } = camelize(messages);
        window.location = redirectUrl;
      } else {
        showErrorMsg(errors);
      }
    });

export const ephotobookPreviewMetadata = file => $.get(`${config.localeApi}/ephotobook/preview_metadata?${file}`);



// WEBPACK FOOTER //
// ./src/Common/Providers/EPhotobookApi.js